import { Link } from "react-router-dom";

import {
  ThreeDotsLoaderAnimatedSvg,
  FormContainer,
  SwitchAppButton,
  ToastNotification,
} from "../../components";
import { IConfirmEmailViewProps } from "./ConfirmEmail";

import emailConfirmationLoadingImage from "../../assets/images/email-confirmation-loading.png";
import emailConfirmationSuccessfulImage from "../../assets/images/chat-history-thumbs-up.png";
import emailConfirmationFailedImage from "../../assets/images/puppy-disconnect-power.jpg";
import switchAppLogo from "../../assets/images/switchapp-logo.svg";

export const View = ({
  email,
  isLoadingConfirmEmail,
  isErrorConfirmEmail,
  emailConfirmationSuccessful,
  redirectToLoginCountdown,
  resendEmailConfirmationLink,
  errorMessage,
}: IConfirmEmailViewProps) => {
  return (
    <div className="confirm-email-page--container flex-container col justify-content--center align-items--center">
      <div>
        <div className="logo-container flex-container justify-content--start">
          <Link to="/">
            <img src={switchAppLogo} alt="logo" />
          </Link>
        </div>

        <FormContainer
          className={`${isErrorConfirmEmail ? "confirmation-failed" : ""}`}
        >
          <div className="form-container flex-container col justify-content--center">
            <div className="form-container__header font-ctm--bold">
              <h3 className={`${isErrorConfirmEmail ? "text-danger" : ""}`}>
                Email Confirmation {isErrorConfirmEmail ? "Failed" : ""}
              </h3>
            </div>

            {isLoadingConfirmEmail ? (
              <div className="flex-container col justify-content--center align-items--center">
                <ThreeDotsLoaderAnimatedSvg fill={"#3b7cff"} height={30} />
                <br />
                <br />
                <h5 className="font-ctm--semibold text-danger mt-5">
                  Confirming your email...
                </h5>
              </div>
            ) : null}

            {!isErrorConfirmEmail ? null : (
              <div className="form-container__body">
                <div className="form-container__body__input-container">
                  <div className="flex-container col">
                    {/* <img
                      src={emailConfirmationFailedImage}
                      alt="confirmation falied"
                      className="info-image"
                    /> */}
                    <h5 className="font-ctm--semibold mt-5">
                      An error occured while confirming your email...
                    </h5>
                    <br />
                    <br />

                    {/* Display any form errors here */}
                    <>
                      {!errorMessage ? null : (
                        <div className="form-error--message">
                          <p className="">Error: {errorMessage}</p>
                          <br />
                          <br />
                          <br />
                          <br />
                        </div>
                      )}

                      <div className="flex-box resend-link-section">
                        <h5 className="font-ctm--semibold">
                          Link not working?{" "}
                        </h5>
                      </div>

                      <SwitchAppButton
                        kind="primary"
                        size="md"
                        onClick={resendEmailConfirmationLink}
                        className="resend-link-button mt-5"
                      >
                        Resend Verification Link
                      </SwitchAppButton>
                    </>
                  </div>
                </div>

                {/* TODO: Automatically redirect to login */}
              </div>
            )}
          </div>

          {emailConfirmationSuccessful ? (
            <>
              <img
                src={emailConfirmationSuccessfulImage}
                alt="confirmation successful"
                className="info-image"
              />

              <div className="flex-box resend-link-section text-center">
                <h5 className="font-ctm--semibold">
                  Your email has been confirmed. <br />
                  <br />
                  <span className="text-success">
                    Redirecting to login in {redirectToLoginCountdown}{" "}
                  </span>
                </h5>
              </div>
            </>
          ) : null}
        </FormContainer>
      </div>
    </div>
  );
};
